class ImpulseSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.impulse-slideshow__slider');
    this.slides = this.querySelectorAll('.impulse-slideshow__slide');
    this.dots = this.querySelectorAll('.impulse-slideshow__dot');
    this.prevBtn = this.querySelector('.impulse-slideshow__btn--prev');
    this.nextBtn = this.querySelector('.impulse-slideshow__btn--next');
    
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed) * 1000 || 5000;
    this.currentIndex = 0;
    this.autoplayInterval = null;

    this.init();
  }

  init() {
    if (!this.slider || this.slides.length === 0) return;

    // Intersection Observer for scroll snapping updates
    const observerOptions = {
      root: this.slider,
      threshold: 0.5
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = Array.from(this.slides).indexOf(entry.target);
          this.updateActiveState(index);
        }
      });
    }, observerOptions);

    this.slides.forEach(slide => this.observer.observe(slide));

    // Event listeners
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));
    }
    if (this.dots.length > 0) {
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });
    }

    if (this.autoplay) {
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      
      // Stop autoplay when user interacts with touch
      this.slider.addEventListener('touchstart', () => this.stopAutoplay(), { passive: true });
    }
  }

  goToSlide(index) {
    if (index < 0) {
      index = this.slides.length - 1;
    } else if (index >= this.slides.length) {
      index = 0;
    }

    const targetSlide = this.slides[index];
    this.slider.scrollTo({
      left: targetSlide.offsetLeft,
      behavior: 'smooth'
    });
  }

  updateActiveState(index) {
    this.currentIndex = index;
    
    // Update slides
    this.slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
    });

    // Update dots
    this.dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      this.goToSlide(this.currentIndex + 1);
    }, this.speed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }
}

if (!customElements.get('impulse-slideshow')) {
  customElements.define('impulse-slideshow', ImpulseSlideshow);
}
